import React from "react";
import "./PhoneLayout.scss";

interface PhoneLayoutProps {
  className?: string;
  children: React.ReactNode;
}

const PhoneLayout: React.FC<PhoneLayoutProps> = ({ children, className }) => {
  return (
    <div className={`phone-layout ${className || ""}`}>
      <div className="inner">{children}</div>
    </div>
  );
};

export default PhoneLayout;
